import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import mixpanel from "mixpanel-browser";
import React, { useCallback, useState } from "react";

import Button from "../../../../../../../shared/components/design-system/Button";
import Dialog from "../../../../../../../shared/components/design-system/Dialog";
import { RequiredNumericInput } from "../../../../../../../shared/components/design-system/TextInput/NumericInput";
import FormLayout, {
  FormLayoutFlags,
} from "../../../../../../../shared/components/design-system/component-groups/FormLayout";
import {
  SectionHeader,
  StandardFormFooter,
} from "../../../../../../../shared/components/design-system/component-groups/section-header-footer";
import { createBlankCaption } from "../utils";
import { INSERT_TABLE_COMMAND } from "./TablePlugin";

export default function InsertTableDialog({ isOpen, close }: { isOpen: boolean; close: () => void }) {
  const [rows, setRows] = useState(5);
  const [columns, setColumns] = useState(5);

  const [editor] = useLexicalComposerContext();

  const handleClose = useCallback(() => {
    mixpanel.track("Closed table insert modal");
    close();
  }, [close]);

  const handleSubmit = useCallback(() => {
    mixpanel.track("Table Inserted", { "Number of rows": rows, "Number of columns": columns });
    editor.dispatchCommand(INSERT_TABLE_COMMAND, {
      columns,
      rows,
      includeHeaders: true,
      caption: createBlankCaption(),
    });
    close();
  }, [close, columns, editor, rows]);

  return (
    <Dialog isOpen={isOpen} onClose={close}>
      <form onSubmit={handleSubmit}>
        <SectionHeader title="Insert table" />
        <FormLayout>
          <RequiredNumericInput
            className={FormLayoutFlags.halfWidth}
            max={99}
            min={1}
            value={rows}
            onChange={setRows}
            label="Number of rows"
          />
          <RequiredNumericInput
            className={FormLayoutFlags.halfWidth}
            max={99}
            min={1}
            value={columns}
            onChange={setColumns}
            label="Number of columns"
          />
        </FormLayout>
        <StandardFormFooter>
          <Button onClick={handleClose} label="Cancel" />
          <Button submit label="Insert" variant="primary" />
        </StandardFormFooter>
      </form>
    </Dialog>
  );
}
